// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"accessible-quick-menu_menuContainer__CE33d","menuLink":"accessible-quick-menu_menuLink__0n_pI"};